import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const CondicionesEditarDialog = ({ visible, onHide, condiciones }) => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');

    const formatChileanPhone = (value) => {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned.length <= 8) {
            return cleaned.replace(/(\d{4})(\d{0,4})/, '$1 $2').trim();
        }
        return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, '+$1 $2 $3').trim();
    };

    const handleTelefonoChange = (e) => {
        const formatted = formatChileanPhone(e.target.value);
        setTelefono(formatted);
    };

    const handleGuardar = () => {
        onHide();
    };

    return (
        <Dialog 
            header="Editar Condición" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
            footer={
                <div className="flex justify-content-end">
                    <Button label="Grabar" icon="pi pi-save" onClick={handleGuardar} />
                </div>
            }
        >
            <div className="p-fluid">
                <div className="field mb-3">
                    <label htmlFor="nombre" className="block mb-2">Nombre</label>
                    <InputText 
                        id="nombre" 
                        value={nombre} 
                        onChange={(e) => setNombre(e.target.value)} 
                        placeholder="Ingrese su nombre"
                    />
                </div>
                <div className="field mb-3">
                    <label htmlFor="correo" className="block mb-2">Correo</label>
                    <InputText 
                        id="correo" 
                        value={correo} 
                        onChange={(e) => setCorreo(e.target.value)} 
                        placeholder="ejemplo@correo.cl"
                    />
                </div>
                <div className="field mb-3">
                    <label htmlFor="telefono" className="block mb-2">Teléfono</label>
                    <InputText 
                        id="telefono" 
                        value={telefono} 
                        onChange={handleTelefonoChange} 
                        placeholder="+56 9 1234 5678"
                        maxLength={12}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default CondicionesEditarDialog;
